import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { useEffectiveUser } from '../contexts/AuthContext';
import UpgradeToAccessModal from './UpgradeToAccessModal';

const PremiumRoute = ({ children }) => {
  const { currentUser } = useEffectiveUser();
  const location = useLocation();
  const [isPremium, setIsPremium] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [accessChecked, setAccessChecked] = useState(false);

  useEffect(() => {
    let unsubscribe = null;

    const setupUserListener = async () => {
      if (currentUser) {
        const userRef = doc(db, 'users', currentUser.uid);
        
        unsubscribe = onSnapshot(userRef, (doc) => {
          if (doc.exists()) {
            const userData = doc.data();
            setIsAdmin(userData.isAdmin || false);
            setIsPremium(userData.membershipLevel === 'premium' || userData.membershipLevel === 'promo');
          }
          setIsLoading(false);
        }, (error) => {
          console.error('Error in user listener:', error);
          setIsLoading(false);
        });
      } else {
        setIsLoading(false);
      }
    };

    setupUserListener();

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [currentUser]);

  // Handle modal close
  const handleCloseModal = () => {
    setShowUpgradeModal(false);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Only redirect after loading is complete and user lacks access
  if (!isPremium && !isAdmin) {
    // Pass showUpgradeModal: true in the state to show the modal on Dashboard
    return <Navigate to="/dashboard" state={{ showUpgradeModal: true, from: location }} replace />;
  }

  return (
    <>
      {children}
    </>
  );
};

export default PremiumRoute; 